import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    borderRadius: 0,
    // marginTop: 50,
  },
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100vh",
  },
  wrapHeader: {
    display: "flex",
    paddingTop: "60px",
    justifyContent: "center",
    marginBottom: "20px",
  },
  wrapAvatar: {
    display: "flex",
    alignItems: "center",
  },
  large: {
    width: 80,
    height: 80,
    border: "2px solid #5675D3",
  },
  previewFotoKursus: {
    width: "100%",
    height: "auto",
  },
  warpText: {
    display: "flex",
    justifyContent: "center",
  },
  liquidPrimary: {
    width: "50%",
    fontWeight:"bold",
    "@media (max-width: 768px)": {
      width: "100%",
    },
    "@media (max-width: 480px)": {
      width: "100%",
    },
  },
  liquidSecondary: {
    width: "50%",
    fontSize: "14px",
    // color: "#6765659E",
    "@media (max-width: 768px)": {
      width: "100%",
    },
    "@media (max-width: 480px)": {
      width: "100%",
    },
  },
}));

export default useStyles;
